import React from "react";
import {
  Cloud12,
  Demography,
  LineChart13,
  LineChart23,
  Topics,
} from "./charts";

export const Consumer = () => (
  <svg viewBox="0 0 108 136">
    <LineChart13 x={8} y={8} />
    <LineChart23 x={40} y={8} />

    <Demography x={8} y={40} />
    <Cloud12 x={56} y={40} />

    <Topics x={8} y={72} />
    <Cloud12 x={56} y={72} />

    <Cloud12 x={8} y={104} />
    <Cloud12 x={56} y={104} />
  </svg>
);
